import React from "react";
import {Route} from "react-router-dom";

import CompanyDepartmentIndex from "./index";

const data = [<Route exact key="CompanyDepartmentIndex" path="/company/department/index" element={<CompanyDepartmentIndex />} />];

export default data;
